import { createBrowserHistory } from 'history';

export const createHistory = (params) => {
  return createBrowserHistory(params);
};
